import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable } from 'rxjs';
import { EntityDataAddress, IEntityData, IEntityDataKeyValue } from '../interfaces/entity.interface';

@Injectable({
  providedIn: 'root'
})
export class EntityService {

  constructor(private _api: ApiService) { }

  getAll(): Observable<IEntityData[]> {
    return this._api.request(ApiServiceHolder.entityData.getAll());
  }

  getByPk(idEntity: number): Observable<IEntityData> {
    return this._api.request(ApiServiceHolder.entityData.getByPk(idEntity));
  }

  getEntity(idEntity: number): Observable<IEntityData> {
    return this.getByPk(idEntity);
  }

  getAllKeyValue(): Observable<IEntityDataKeyValue[]> {
    return this._api.request(ApiServiceHolder.entityData.getAllKeyValue());
  }
  getAllSellerKeyValue(): Observable<IEntityDataKeyValue[]> {
    return this._api.request(ApiServiceHolder.entityData.getAllSellerKeyValue());
  }

  save(entity: IEntityData) {
    return this._api.request<IEntityData>(ApiServiceHolder.entityData.save(entity));
  }

  delete(idEntity: number) {
    return this._api.request(ApiServiceHolder.entityData.delete(idEntity));
  }

  getAddresses(idEntity: number): Observable<EntityDataAddress[]> {
    return this._api.request(ApiServiceHolder.entityData.getAddresses(idEntity));
  }
}
